export default __webpack_public_path__ + "static/media/qr-code-white.f3fc47ad.svg";